import { apiService } from "../api";

export async function createFeedback(programId: string, payload: object) {
  const response = await apiService({
    url: `/feedback/program/${programId}`,
    method: "post",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

/**
 * GET /program/{programId}/feedback
 * Gets all feedbacks for a program
 */
export async function getFeedbacks(programId: string) {
  const response = await apiService({
    url: `/feedback/program/${programId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}

/**
 * GET /feedback/program/{programId}
 */
export async function getFeedback(programId: string) {
  const response = await apiService({
    url: `/feedback/${programId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}

export async function getFeedbackPopup(feedbackId: string) {
  const response = await apiService({
    url: `/feedback/${feedbackId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}

export async function deleteFeedback(feedbackId: string) {
  const response = await apiService({
    url: `/feedback/${feedbackId}`,
    method: "delete",
    protectedRoute: true,
  });
  return response;
}

/**
 * Update a feedback
 * PUT /feedback/program/{program_id}/{feedback_id}
 */
export async function updateFeedback(programId: string, feedbackId: string, payload: object) {
  const response = await apiService({
    url: `/feedback/program/${programId}/${feedbackId}`,
    method: "put",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

/**
 * Change feedback state (start/stop)
 * PUT /feedback/{feedback_id}
 */
export async function changeFeedbackState(feedbackId: string, action: "start" | "stop", user: string) {
  const response = await apiService({
    url: `/feedback/state/${feedbackId}`,
    method: "put",
    protectedRoute: true,
    requestData: {
      action,
      user
    },
  });
  return response;
}

export const bulkFeedbackUpdate = async (payload: {
    action: string;
    feedback_ids: string[];
}) => {
    return await apiService({
        url: `/feedback/state/bulk`,
        method: "put",
        protectedRoute: true,
        requestData: payload
    })
}
export const getFeedbackCategories = async ()  =>{
  const response = await apiService({
    url: `/feedback/categories`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}